import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import _, { isEmpty, get } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FileSaver from 'file-saver';
import moment from 'moment';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import routes from '../../../../routes';

import { options } from './constant';
// import { } from '../../../../actions';
import { PERMISSION } from '../../../../constants/permission';
import { checkPermission } from '../../../../utils/route-auth';
import { handleError, handleFieldError } from '../../../../utils/form-validation';
import { sortArray } from '../../../../selectors';
import Input from '../../../../components/FormElements/Input';
import Select from '../../../../components/FormElements/Select';
import ModalConfirmation from '../../../../components/ModalConfirmation';

import {
    getListDspPlatformAction
} from '../../../../actions';

const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../../components/Modal'));



class index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            form: {},
            touched: {},
            errors: {},
            submited: false,
            confirmationOpen: false,
            confirmationInfo: '',
            platformTableData: []

        }
    }


    async componentWillMount() {

        const { tenantId, authToken, userId, getHierarchyListAction } = this.props;
        await this.listAllData();

    }


    async listAllData() {
        const { tenantId, authToken, userId, getListDspPlatformAction, configurationList } = this.props;
        // console.log(this.props);
        const {
            responseCode: { status = "" },
            responseList,
        } = await getListDspPlatformAction({ tenantId, authToken, userId });
        if (status == "Success") {
            // console.log(responseList, "rs")

            this.setState({ platformTableData: responseList });
        }

    }



    handleAction = (row, action) => {

        const { match, history } = this.props;
        if (action.type == 'edit') {
            history.push(`${match.path}/${routes.dataConfig.dspPlatform.editDspPlatform}/${row.id}`)
        }

    }






    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };
    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    render() {
        const { openModal, errors, form, submited, touched, confirmationInfo, confirmationOpen, platformTableData } = this.state;
        const { history } = this.props
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggalConfirmationModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3">
                            {/* <Card>

                                <Tabs container="dataConfig" />
                            </Card> */}
                            <Card >
                                <Tabs container="dataConfig" />
                                <div className="table-responsive">
                                    <Table
                                        options={options}
                                        data={platformTableData}
                                        handelAction={this.handleAction}
                                    />
                                </div>

                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}


export default withRouter(connect(
    (state) => ({

        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', ''),
    }), {
    getListDspPlatformAction
}
)(index));

index.propTypes = {
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getAprAction: PropTypes.func,
    getSegmentListAction: PropTypes.func,
};
